;(function($){

    function Select()
    {
        $('select').each(function( index, value) {

            $(value).append('<option value="" '+ ($(value).val() == "") ? 'selected' : '' +'>Selecione </option>').select2({
                placeholder: "Selecione",
                allowClear: true
            });
        });

        var ele = $('select');

        // gaurav jain: quick fix for select2 not closing on mobile devices
        ele.on("select2:close", function () {
            setTimeout(function () {
                $('.select2-container-active').removeClass('select2-container-active');
                $(':focus').blur();
            }, 1);
        });

        // gaurav jain: quick fix for select2 not opening on mobile devices if with textbox
        ele.on('select2:open', function () {
            $('.select2-search__field').prop('focus', false);
        });

        $(document).on("change", "input[name='tabs']", function(e){
            $('select').each(function( index, value) {                
                $(value).select2({
                    placeholder: "Selecione",
                    allowClear: true
                });

                $(value).append('<option value="" '+ ($(value).val() == "") ? 'selected' : '' +'>Selecione </option>').trigger('change');    
            });
        });            
    }

   	new Select();

}(jQuery));
 
 
 
 
